module.exports = __webpack_public_path__ + "img/r1.f8d3a32e.png";